import { render, staticRenderFns } from "./SerpApiEditor.vue?vue&type=template&id=e5ed1624"
import script from "./SerpApiEditor.vue?vue&type=script&lang=js"
export * from "./SerpApiEditor.vue?vue&type=script&lang=js"
import style0 from "./SerpApiEditor.vue?vue&type=style&index=0&id=e5ed1624&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports